import styled from "styled-components";
import {Tabs as AntdTabs} from "antd";

export const Tabs = styled(AntdTabs)`
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
  .ant-tabs-tab:hover,
  .ant-tabs-tab-btn:active {
    color: #fff;
  }
  .ant-tabs-ink-bar {
    background: #00eec2;
  }
`
